(function() {
    'use strict';

    angular
        .module('eDocumentsApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        return {
            restrict        : 'A',
            scope           : {
                predicate: '=jhSort',
                ascending: '=',
                callback : '&'
            },
            controller      : SortController,
            controllerAs    : 'vm',
            bindToController: true
        };
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('i.fas'),
                sortIcon = 'fa-sort',
                sortAsc = 'fa-sort-amount-down',
                sortDesc = 'fa-sort-amount-up',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('i.sort'),
                sortIcon = 'fa-sort',
                sortAsc = 'fa-sort-amount-down',
                sortDesc = 'fa-sort-amount-up';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
